import { render, staticRenderFns } from "./CerCourseByBuy.vue?vue&type=template&id=b56e9eea&scoped=true&"
import script from "./CerCourseByBuy.vue?vue&type=script&lang=js&"
export * from "./CerCourseByBuy.vue?vue&type=script&lang=js&"
import style0 from "./CerCourseByBuy.vue?vue&type=style&index=0&id=b56e9eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56e9eea",
  null
  
)

export default component.exports